import React from 'react';
import { StructMapData } from 'components/struct-map/struct-map-types';

export const nodeTooltipMapper = (data: StructMapData) => undefined;

export const leafTooltipMapper = (data: StructMapData) => {
  const { label, fileRef, aisId } = data;

  return (
    <>
      Popis: <b>{label}</b>
      <br />
      Originální název souboru: <b>{fileRef?.name}</b>
      <br />
      AIS ID: <b>{aisId}</b>
      <br />
    </>
  );
};
